export const enum TEST_EQUIPMENT_DEVICE_LIST {
  GPS_DEVICE = 'gps_device',
  LACTATE_METER = 'lactate_meter',
  POWER_METER = 'power_meter',
  VO2_ANALYZER = 'vo2_analyzer',
  VCO2_ANALYZER = 'vco2_analyzer',
  VCO2_VO2_ANALYZER = 'vco2_vo2_analyzer',
  RUNNING_TREADMILL = "running_treadmill",
  CYCLING_ERGOMETER = "cycling_ergometer",
  ROWING_ERGOMETER = "rowing_ergometer",
  SKIING_ERGOMETER = "skiing_ergometer",
  KAJAK_ERGOMETER = "kajak_ergometer",
}

export const ATHLETE_EQUIPMENT_CATEGORIES = [
  TEST_EQUIPMENT_DEVICE_LIST.GPS_DEVICE,
  TEST_EQUIPMENT_DEVICE_LIST.LACTATE_METER,
  TEST_EQUIPMENT_DEVICE_LIST.POWER_METER
];
